import { renderSlider } from 'js/slider.jsx'
import { renderSliderImageVideo } from 'js/sliderImageVideo'
import { renderCarousel } from 'js/carousel'
import renderBenefitsWidget from 'js/components/benefits/benefits'
import renderSliderCols from 'js/slider3col'
import renderSliderOneCol from 'js/slider1col'
import { renderSliderBig } from 'js/sliderBig'
import { renderHotelSlider } from 'js/slickSlider'
import { renderTab } from 'js/tabSlider'
import { renderTabs } from 'js/tabs'
import { renderAccordions } from 'js/accordions'
import { renderPriceDecrease } from 'js/priceDecrease'
import { renderHotelIntroSliderDots } from 'js/hotelIntroSliderDots'
import reactHotelIntroSlider from 'js/components/hotelIntroSlider/HotelIntroSlider'
import { renderSliderQuotes } from 'js/quotesSlider'
import { renderDestinationFilter } from 'js/destinationFilter'
import { rendertabsImages } from 'js/tabsImages'
import renderTabFaq from 'js/tabFaq'
import renderDestinationMap from 'js/destination-map'
import initAppHotelAccordion, {scrollToSection} from './appHotelAccordion'
import renderCheckSlider from 'js/checkSlider'
import { renderPersonalData } from 'js/personalData'
import iframeLoaded from 'js/iframeFullHeight'
import { renderSliderAllHotels } from 'js/sliderAllHotels'
import { renderInputPhone } from 'js/intlTelInput'
import renderSliderMultiPicture from 'js/multiPictureSlider'
import pushToContentsquare, {pushDestinationSearch} from 'js/helpers/contentsquare'

import {pushGA4} from 'js/helpers/dataLayerPush';
import {pushDestinationTestSearch} from 'js/helpers/gtm';
import renderReactModals, {openReactModalEvent, closeReactModalEvent} from 'js/components/ReactModals'
import checkNavigationType from 'js/shared/checkNavigationType';
import { renderHotelAll } from 'js/hotelAll';

import 'js/components/quotes'
import 'js/components/video'
import 'js/components/push'
import 'js/components/hero'
import 'js/components/conditions'
import 'js/components/destinationFullMap'
import 'js/rotate'
import './allPagesMain.scss'

window.pushGA4 = pushGA4;
window.pushGtm = {
  pushDestinationTestSearch,
  pushGA4
}
window.pushContentSquare = {
  push: pushToContentsquare,
  pushDestinationSearch,
}
window.renderSlider = renderSlider
window.renderSliderImageVideo = renderSliderImageVideo
window.renderCarousel = renderCarousel
window.renderBenefitsWidget = renderBenefitsWidget
window.renderHotelSlider = renderHotelSlider
window.renderTab = renderTab
window.renderTabs = renderTabs
window.renderAccordions = renderAccordions
window.renderSliderCols = renderSliderCols
window.renderSliderOneCol = renderSliderOneCol
window.renderSliderBig = renderSliderBig
window.renderPriceDecrease = renderPriceDecrease
window.renderHotelIntroSliderDots = renderHotelIntroSliderDots
window.renderHotelIntroSliderReact = reactHotelIntroSlider
window.renderSliderQuotes = renderSliderQuotes
window.renderDestinationFilter = renderDestinationFilter
window.rendertabsImages = rendertabsImages
window.renderTabFaq = renderTabFaq
window.renderDestinationMap = renderDestinationMap
window.renderCheckSlider = renderCheckSlider
window.renderPersonalData = renderPersonalData
window.iframeLoaded = iframeLoaded // seems not used
window.renderSliderAllHotels = renderSliderAllHotels
window.renderInputPhone = renderInputPhone
window.renderSliderMultiPicture = renderSliderMultiPicture
window.checkNavigationType = checkNavigationType;
window.reactModals = {
  render: renderReactModals,
  open: openReactModalEvent,
  close: closeReactModalEvent,
};
window.renderHotelAll = renderHotelAll;
window.initAppHotelAccordion = initAppHotelAccordion;
window.hotelAccordion = {
  init: initAppHotelAccordion,
  scrollToSection,
}
